import { NotificationStore } from "@/components/NotificationPlugin";
import { snakeCase } from "snake-case";
import camelCase from "lodash/camelCase";
import keys from "lodash/keys";
import FileType from "file-type/browser";
import Vue from "vue";

const Message = {
  error: function(message) {
    NotificationStore.notify({
      message: message,
      icon: "add_alert",
      horizontalAlign: "right",
      verticalAlign: "top",
      type: "danger"
    });
  },

  success: function(message) {
    NotificationStore.notify({
      message: message,
      icon: "add_alert",
      horizontalAlign: "right",
      verticalAlign: "top",
      type: "success"
    });
  },

  info: function(message) {
    NotificationStore.notify({
      message: message,
      icon: "add_alert",
      horizontalAlign: "right",
      verticalAlign: "top",
      type: "info"
    });
  }
};

function hasHistory() {
  return window.history.length > 1;
}

async function validateFileType(fileObj, type = "") {
  const fileType = await FileType.fromBlob(fileObj);

  console.log("[UPLOADED_FILE_TYPE] :  ", fileType);

  if (!fileType) {
    Message.error("Can't determine your file type !");
    return false;
  }

  const isValid = fileType.mime.indexOf(type) > -1;

  if (!isValid) {
    Message.error(`Only support upload  ${type} file!`);
    return false;
  }

  return true;
}

async function getUploadedImgUrl(fileObj) {
  const isImgType = await validateFileType(fileObj, "image");

  if (!isImgType) return "";

  return window.URL.createObjectURL(fileObj);
}

const convertObj = {
  camelCaseToSnakeCase: function(obj) {
    let optRes = obj instanceof Array ? [] : {};

    return Object.keys(obj).reduce((scObj, camelCaseKey) => {
      const data = obj[camelCaseKey];
      const snakeCaseKey = snakeCase(camelCaseKey);

      if (data instanceof Date) {
        scObj[snakeCaseKey] = data.toString();
        return scObj;
      }

      if (data && (typeof data === "object" || data instanceof Array)) {
        scObj[snakeCaseKey] = convertObj.camelCaseToSnakeCase(data);

        return scObj;
      }

      scObj[snakeCaseKey] = data;
      return scObj;
    }, optRes);
  },
  snakeCaseToCamelCase: function(obj) {
    let optRes = obj instanceof Array ? [] : {};

    return Object.keys(obj).reduce((ccObj, snakeCaseKey) => {
      const data = obj[snakeCaseKey];
      const camelCaseKey = camelCase(snakeCaseKey);

      if (data instanceof Date) {
        ccObj[camelCaseKey] = data.toString();
        return ccObj;
      }

      if (data && (typeof data === "object" || data instanceof Array)) {
        ccObj[camelCaseKey] = convertObj.snakeCaseToCamelCase(data);

        return ccObj;
      }

      ccObj[camelCaseKey] = data;
      return ccObj;
    }, optRes);
  }
};

/**
 * Just get 1 message error
 * @param {*} serverErrMsg has format: messages = { key_1: ['message_1',...,'message_N'], key_1: ['message_1',...,'message_N']}
 * @returns messages = {key_1: 'message_1', key_2: 'message_1'}
 */

const genErrMsgOj = function(serverErrMsg) {
  return Object.keys(serverErrMsg).reduce((errMsgObj, errField) => {
    errMsgObj[errField] = serverErrMsg[errField][0];
    return errMsgObj;
  }, {});
};

const getFileNameObj = function(orgFileName) {
  const lastDotIdx = orgFileName.lastIndexOf(".");

  return {
    name: orgFileName.slice(0, lastDotIdx),
    ext: orgFileName.slice(lastDotIdx + 1)
  };
};

const initLoader = () =>
  Vue.$loading.show({
    // Optional parameters
    // container: document.body,
    canCancel: false,
    color: "#00bcd4",
    zIndex: 9999,
    enforceFocus: false
  });

const getPieceObj = (pieceObj, originalObj) => {
  return Object.keys(pieceObj).reduce((newPieceObj, field) => {
    newPieceObj[field] = originalObj[field] || pieceObj[field];
    return newPieceObj;
  }, {});
};

const goToPreviousPage = router => {
  if (!router) {
    console.error("Do you forgot passing router instance?");
    return;
  }

  return hasHistory() ? router.go(-1) : router.push("/");
};

const generatePdfSrc = (data, config) => {
  const blob = new Blob([data], {
    type: "application/pdf"
  });
  const objectUrl = URL.createObjectURL(blob);
  const stringOpt = keys(config).map(key => {
    return `${key}=${config[key]}`;
  });
  return `${objectUrl}#${stringOpt.join("&")}`;
};

const downloadByUrl = (url, filename) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const getId = obj => {
  if (!obj) return "";

  return obj.id || obj._id;
};

const getNoSQLUser = data => {
  const { users } = data;

  if (!users) return null;

  const { user_no_sql: userInfo } = users;

  return userInfo;
};

const capitalizeFirstLetter = item => {
  return item[0].toUpperCase() + item.slice(1);
};

const percentDataChart = data => {
  const total = data.reduce((total, currentValue) => total + currentValue, 0);
  let percent = {};
  data.map((data, index) => {
    percent[index] = ((data / total) * 100).toFixed(2);
  });
  return percent;
};

const setCookie = (name, value, expdays) => {
  let d = new Date();
  d.setTime(d.getTime() + expdays * 864e5);
  let expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

const getCookie = cookieName => {
  let name = cookieName + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const deleteCookie = cookieName => {
  this.setCookie(cookieName, "", -1);
};
const createHashCode = () => {
  return Math.random()
    .toString(36)
    .substring(7);
};

const schoolYears = () => {
  const currentYear = new Date("2017").getFullYear();
  const arr = Array(20).fill("");
  return arr.map((_, idx) => {
    let year = `${currentYear + idx}-${currentYear + idx + 1}`;
    return {
      id: year,
      name: year
    };
  });
};

export {
  hasHistory,
  Message,
  getUploadedImgUrl,
  convertObj,
  genErrMsgOj,
  getFileNameObj,
  initLoader,
  getPieceObj,
  goToPreviousPage,
  generatePdfSrc,
  downloadByUrl,
  getId,
  getNoSQLUser,
  percentDataChart,
  setCookie,
  getCookie,
  deleteCookie,
  capitalizeFirstLetter,
  createHashCode,
  schoolYears
};
